import { j as r } from "../../../chunks/jsx-runtime.DGlMoOmv.js";
import d from "react";
import { c as o } from "../../../chunks/index.CxSWpsOB.js";
const i = d.forwardRef(({
  className: a,
  ...t
}, e) => /* @__PURE__ */ r.jsx("div", { ref: e, className: o("tw-rounded-4 tw-border tw-border-gray-300 tw-bg-base-white tw-p-16 tw-w-full tw-flex tw-flex-col", a), ...t }));
i.displayName = "MarketingCard";
const w = d.forwardRef(({
  className: a,
  ...t
}, e) => /* @__PURE__ */ r.jsx("div", { ref: e, className: o("tw-flex tw-flex-col tw-gap-4 tw-mb-4", a), ...t }));
w.displayName = "MarketingCardHeader";
const n = d.forwardRef(({
  className: a,
  children: t,
  ...e
}, s) => /* @__PURE__ */ r.jsx("h3", { ref: s, className: o("tw-headline-1-m tw-text-gray-900 tw-m-0", a), ...e, children: t }));
n.displayName = "MarketingCardTitle";
const l = d.forwardRef(({
  className: a,
  ...t
}, e) => /* @__PURE__ */ r.jsx("div", { ref: e, className: o("tw-body-2 tw-text-gray-600", a), ...t }));
l.displayName = "MarketingCardDescription";
const m = d.forwardRef(({
  className: a,
  ...t
}, e) => /* @__PURE__ */ r.jsx("div", { ref: e, className: o("tw-body-1-long tw-text-gray-600 tw-m-0", a), ...t }));
m.displayName = "MarketingCardContent";
const f = d.forwardRef(({
  className: a,
  ...t
}, e) => /* @__PURE__ */ r.jsx("div", { ref: e, className: o("tw-pt-8 tw-mt-auto", a), ...t }));
f.displayName = "MarketingCardFooter";
export {
  i as MarketingCard,
  m as MarketingCardContent,
  l as MarketingCardDescription,
  f as MarketingCardFooter,
  w as MarketingCardHeader,
  n as MarketingCardTitle
};
//# sourceMappingURL=index.js.map
